import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import util from '@/util'
import mascaras from '@/util/mascaras'
import Endereco from '@/components/layout/endereco/Endereco.vue'
import TelefoneInput from '@/components/layout/telefone/TelefoneInput'
import constants from '@/util/constants'

export default {
  name: 'dados-escritorio',
  components: {
    spinnerProcessando,
    Endereco,
    TelefoneInput
  },
  props: {
    escritorio: {
      type: Object,
      required: true
    }
  },

  computed: {
    podeAvancar () {
      this.validarCampos()
      return Object.values(this.listaDeErros).length === 0
    },
    mascaraCep () {
      return mascaras.mascarasParaCampos.cep
    },
    formulario: {
      get () {
        return this.escritorio
      },
      set (escritorio) {
        this.$emit('update:escritorio', { ...escritorio })
      }
    }
  },
  data: () => {
    return {
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      listaDeErros: {}
    }
  },

  mounted () {
    this.formulario = this.escritorio
  },
  methods: {
    mascaraFone (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    },
    mapearListaDeErros () {
      const errosEndereco = Object.fromEntries(
        Object.entries(this.listaDeErros)
          .filter(([chave]) => chave.startsWith('escritorio.endereco'))
          .map(([chave, erro]) => {
            const novaChave = chave.split('.').slice(2).join('.')
            return [novaChave, erro]
          })
      )
      return errosEndereco ?? []
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    mascaraDocumento (valor) {
      return mascaras.mascaraCpfCnpj(valor)
    },
    validarCampos () {
      this.listaDeErros = {}
      const nomeEscritorio = this.formulario.nome
      const cpfCnpj = this.formulario.cpf_cnpj
      const email = this.formulario.email
      const numeroTelefone = this.formulario.numero_telefone
      const cep = this.formulario.endereco.cep
      const logradouro = this.formulario.endereco.endereco
      const numero = this.formulario.endereco.numero
      const bairro = this.formulario.endereco.bairro
      const cidade = this.formulario.endereco.cidade
      const estado = this.formulario.endereco.uf

      if (util.valorVazio(nomeEscritorio)) {
        this.listaDeErros['escritorio.nome'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(cpfCnpj)) {
        this.listaDeErros['escritorio.cpf_cnpj'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(email)) {
        this.listaDeErros['escritorio.email'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(numeroTelefone)) {
        this.listaDeErros['escritorio.numero_telefone'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(cep)) {
        this.listaDeErros['escritorio.endereco.cep'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(logradouro)) {
        this.listaDeErros['escritorio.endereco.endereco'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(numero)) {
        this.listaDeErros['escritorio.endereco.numero'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(bairro)) {
        this.listaDeErros['escritorio.endereco.bairro'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(cidade)) {
        this.listaDeErros['escritorio.endereco.cidade'] = 'Este campo é obrigatório.'
      }
      if (util.valorVazio(estado)) {
        this.listaDeErros['escritorio.endereco.uf'] = 'Este campo é obrigatório.'
      }
      this.mapearListaDeErros()
    },
    async obterUnidadesFederativas (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'nome': valorDigitadoParaBusca }
      }
      const resposta = await this.axios.post('/manager/unidades-federativas', parametrosRequisicao)
      const listaUnidadesFederativas = resposta.data.retorno.dados
      callbackFlagCarregamento = false
      return listaUnidadesFederativas
    }
  }
}
